<template>
  <ul class="c-navigation__system-status">
    <li class="c-navigation-item">
      <app-navigation-link
        :link="{to: '/system-status', text: `System Status`, icon: 'signal',iconColor: globalStatus, viewAll: true}"
      ></app-navigation-link>
    </li>
    <li
      class="c-navigation-item--system v-hide"
      v-for="(system, index) in localSystems"
      :key="system.id"
    >
      <app-navigation-link
        :link="{to: '/system-status', text:system.name, icon: 'signal',iconColor: getStatus(system.value), children:system.children, isOpen: system.isOpen}"
        @dropdown-click="getCurrentStatus(system)" v-if="index <= 2"
      ></app-navigation-link>
      <ul v-if="system.isOpen" class="service-update">
        <li>{{system.children[0].text}}<br />
        <date-time :date="system.children[0].created_time" /></li>
      </ul>
    </li>
  </ul>
</template>

<script>
/**
 * Get a list of all systems that are currently affected
 */

import { mapState, mapGetters } from "vuex";
import AppNavigationLink from "@/components/AppNavigationLink";
import AppNavigationList from "@/components/AppNavigationList";
const DateTime = () => import("@/components/BaseDateTime")

export default {
  name: "app-navigation-systems",
  props: {
    load: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      localSystems: []
    };
  },

  components: {
    AppNavigationLink,
    AppNavigationList,
    DateTime
  },

  methods: {
    getCurrentStatus(system) {
      const status = system.isOpen;

      //when someone clicks on an icon, we want to retrieve the latest status at that point
      this.$store
        .dispatch("systems/getCurrentStatus", system.id)
        .then(resp => {
          this.$set(system, "children", [
            { text: resp.data.data.update[0].description, created_time:  resp.data.data.update[0].created_time}
          ]);
          this.$set(system, "isOpen", !status);
        })
        .catch(err => {
          this.$set(system, "children", [
            { text: "Could not retrieve status" }
          ]);
          this.$set(system, "isOpen", !status);
        });
    },
    getStatus(val) {
      switch (val) {
        case 1:
          return "#16a446"; //green
          break;
        case 2:
          return "#e3793b"; //amber
          break;
        default:
          return "#DA291C"; //red
          break;
      }
    }
  },

  computed: {
    ...mapGetters("systems", ["navigationSystems"]),

    globalStatus() {
      if (this.localSystems) {
        const red = this.localSystems.filter(system => system.value === 0);

        if (red.length > 0) {
          return "#DA291C";
        }

        const amber = this.localSystems.filter(system => system.value === 2);

        if (amber.length > 0) {
          return "#e3793b";
        }

        return "#16a446";
      }
    },
  },

  mounted() {
    
    this.$store
      .dispatch("systems/list")
      .then(() => {
        this.localSystems = this.navigationSystems
      });
  }
};
</script> 

<style lang="scss" scoped>
.c-navigation-list {
  &__item {
    display: none;
  }
}
</style>

<style lang="scss">
.c-navigation__system-status {
  background: $colour-nhs-white;
  border-right: 1px solid $colour-nhs-pale-grey;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  a {
    color: #202020;
  }
}

.v-hide {
  // display: none;
  display: block;

  &--md {
    @media screen and (min-height: 1050px) {
      display: block;
    }
  }

  &--lg {
    @media screen and (min-height: 1280px) {
      display: block;
    }
  }

  &--xl {
    @media screen and (min-height: 1350px) {
      display: block;
    }
  }

  // .v-hide
  // @media screen and (min-height: 1050px) {

  // }
}

.c-navigation-item--system {
  .c-navigation-link__icon {
    // height: 14px;
    // width: 14px;
  }
  .c-navigation-link__text {
    font-size: 14px;
    color: $colour-nhs-dark-grey;
  }
}

ul.service-update li {
  color: $colour-nhs-dark-grey;
  padding: 10px 10px 10px 20px;
  font-size: 14px;
}

.is-closed {
  .service-update {
    display: none;
  }
}
</style>


<style lang="scss">
.service-update {
  .c-datetime {
    color: $colour-nhs-mid-grey;
    margin: 5px 0;
  }
}
</style>